import { NextSeo } from 'next-seo';
import ContactUsPage from '_components/composed/pages/ContactUsPage';

export default function ContactUs() {
  return (
    <>
      <NextSeo
        title="Contact Incorpified - We’re Here to Help with Your Business Needs"
        description="Get in touch with Incorpified. Our support team is ready to assist you with all your business incorporation and service inquiries."
      />
      <ContactUsPage />
    </>
  );
}
